import * as yup from 'yup';

const number = {
  base: yup.number().typeError('errorMessages.number')
};
number.required = number.base.required('errorMessages.required');
number.optional = yup.lazy(value => (value === '' ? yup.mixed() : number.base));

export default number;
